/* eslint-disable sort-keys */
import { Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ExercisesCardTable } from "../../components/ExercisesCard";
import { useEditionsQuery } from "../../queries/general";
import type { ExercisesList, Teacher } from "../../types";

export function TabsContentExercises(
  { 
    teachers,
    exercises
  }:{
    teachers: Teacher[],
    exercises: ExercisesList,
  }
) {
  const { 
    data: editions
  } = useEditionsQuery({
    classroomId: "0",
    enabled: false
  });
  const editionBooked = editions?.find(edition => edition.status === "E");
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Typography
        color={ theme.customColors.textPrimary }
        fontSize={ "1.25rem" }
        fontWeight={ 400 }
        marginBottom={ theme.spacing(3) }
        lineHeight={ "1.5rem" }
      >
        { t("upload_exercises_description") }
      </Typography>
      <ExercisesCardTable 
        teachers={ teachers }
        editionId={ editionBooked?.id ?? 0 }
        exercises= { exercises  }>
      </ExercisesCardTable>
    </>
  );
}
